import { Serializable } from './Serializable';
import { ClientDTO } from './ClientDTO';

export class Page<T> extends Serializable {
    currentPage: number;
    length: number;
    pageSize: number;
    
    results: T[];

    constructor() {
        super();
    }

}
